import { render, staticRenderFns } from "./MultiContactUs.vue?vue&type=template&id=2bb2995b&"
import script from "./MultiContactUs.vue?vue&type=script&lang=js&"
export * from "./MultiContactUs.vue?vue&type=script&lang=js&"
import style0 from "./MultiContactUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports